import type { Maybe } from '@/shared/libs';
import type { User } from '@psp-aggregator/sdk';

export const isSelfUser = (user: User, currentUserId: Maybe<string>): boolean =>
  Boolean(currentUserId) && user.id === currentUserId;

export const isLastActiveSuperAdmin = (
  user: User,
  activeSuperAdminTotal: number,
): boolean =>
  user.role === 'super_admin' &&
  user.status === 'active' &&
  activeSuperAdminTotal <= 1;
